import React from 'react';
import { Alert, Box, Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { formatMoney } from '../utils/format';
import { tokens } from '../theme';

// The one-ruble test tariff: only a way into the service, for checking online payment and the
// partner program end to end. The server offers it only where it is switched on.
const TestTariffCard = ({ plan, onlinePayment, busy, error, onBuy }) => (
  <Card sx={{ mb: 3, border: `1.5px dashed ${tokens.borderStrong}`, boxShadow: 'none', bgcolor: tokens.paper }}>
    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2.5, flexWrap: 'wrap' }}>
      <Box sx={{ flex: 1, minWidth: 260 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.75 }}>
          <Typography variant="h3">{plan.name}</Typography>
          <Chip size="small" label="для проверки" sx={{ bgcolor: tokens.warningSoft, color: tokens.warning, fontWeight: 700 }} />
        </Stack>
        <Stack spacing={0.4}>
          {plan.features.map((f) => (
            <Stack key={f.text} direction="row" spacing={0.75} alignItems="flex-start">
              <CheckRoundedIcon sx={{ fontSize: 16, mt: '3px', color: tokens.primary }} />
              <Typography variant="body2" color="text.secondary">{f.text}</Typography>
            </Stack>
          ))}
        </Stack>
        {error && <Alert severity="error" sx={{ mt: 1.5 }}>{error}</Alert>}
      </Box>
      <Box sx={{ textAlign: 'right' }}>
        <Typography sx={{ fontSize: '1.75rem', fontWeight: 700, lineHeight: 1.1 }}>{formatMoney(plan.price)}</Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>за {plan.months} мес.</Typography>
        <Button variant="contained" onClick={onBuy} disabled={busy}>
          {busy ? 'Оформляем…' : (onlinePayment ? `Оплатить ${formatMoney(plan.price)}` : 'Оформить заявку')}
        </Button>
      </Box>
    </CardContent>
  </Card>
);

export default TestTariffCard;
